import React, { useEffect, useState } from "react";
import { Space, Tooltip, Popconfirm, Button, Modal, Form, Input, Select } from "antd";
import { UserAddOutlined, EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import PageTableLayout from "../../components/Pagetablelayout";

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [form] = Form.useForm();

  const token = localStorage.getItem("jwt");

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await axios.get("https://mdgholidaydreams.com/api/users", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers(res.data);
    } catch (err) {
      console.error("API error:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleAdd = () => {
    setEditingUser(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingUser) {
        await axios.put(`https://mdgholidaydreams.com/api/users?id=${editingUser.id}`, values, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else {
        await axios.post("https://mdgholidaydreams.com/api/users", values, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }
      setIsModalVisible(false);
      setEditingUser(null);
      form.resetFields();
      fetchUsers();
    } catch (err) {
      console.error("Save failed:", err);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setEditingUser(null);
    form.resetFields();
  };

  const columns = [
    { title: "USER NAME", dataIndex: "username", key: "username" },
    { title: "EMAIL", dataIndex: "email", key: "email" },
    { title: "PHONE NUMBER", dataIndex: "phone_number", key: "phone_number", render: val => val || "-" },
    { title: "COUNTRY", dataIndex: "country", key: "country", render: val => val || "-" },
    { title: "CITY", dataIndex: "city", key: "city", render: val => val || "-" },
    { title: "CREATED BY", dataIndex: "created_by", key: "created_by", render: val => val || "-" },
    {
      title: "ACTIONS",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <Space size={12}>
          <Tooltip title="Assign Role">
            <UserAddOutlined
              style={{ color: "#800080", fontSize: 18, cursor: "pointer" }}
              onClick={async () => {
                try {
                  await axios.patch(`https://mdgholidaydreams.com/api/users?id=${record.id}`, 
                    { role_id: 2 }, // example role_id
                    { headers: { Authorization: `Bearer ${token}` } }
                  );
                  fetchUsers();
                } catch (err) {
                  console.error("Assign role failed:", err);
                }
              }}
            />
          </Tooltip>
          <Tooltip title="Edit">
            <EditOutlined
              style={{ color: "#22a722", fontSize: 18, cursor: "pointer" }}
              onClick={() => {
                setEditingUser(record);
                setIsModalVisible(true);
                form.setFieldsValue(record);
              }}
            />
          </Tooltip>
          <Tooltip title="Deactivate">
            <Popconfirm
              title="Deactivate this user?"
              okText="Yes"
              cancelText="No"
              okButtonProps={{ danger: true }}
              onConfirm={async () => {
                try {
                  await axios.patch(`https://mdgholidaydreams.com/api/users?id=${record.id}`, {}, {
                    headers: { Authorization: `Bearer ${token}` }
                  });
                  fetchUsers();
                } catch (err) {
                  console.error("Deactivate failed:", err);
                }
              }}
            >
              <DeleteOutlined style={{ color: "#ef4444", fontSize: 18, cursor: "pointer" }} />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      <PageTableLayout
        breadcrumb={["System", "Users"]}
        title="Users"
        addButtonLabel="Add User"
        onAdd={handleAdd}
        columns={columns}
        dataSource={users}
        loading={loading}
        onRefresh={fetchUsers}
        rowKey="id"
      />

      <Modal
        title={editingUser ? "Edit User" : "Add New User"}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Save"
        width={600}
      >
        <Form form={form} layout="vertical">
          <Form.Item name="username" label="Username" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="email" label="Email" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="phone_number" label="Phone Number">
            <Input />
          </Form.Item>
          <Form.Item name="country" label="Country">
            <Input />
          </Form.Item>
          <Form.Item name="city" label="City">
            <Input />
          </Form.Item>
          <Form.Item name="active" label="Status" rules={[{ required: true }]}>
            <Select placeholder="Select status">
              <Select.Option value={1}>Active</Select.Option>
              <Select.Option value={0}>Inactive</Select.Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
